export const BASE_URL = 'https://api.centsdonations.com/v2/tap-to-donate-dashboard'
export const COMMON_BASE_URL = 'https://api.centsdonations.com/v2/tap-to-donate-common'
export const AUTH_BASE_URL = 'https://auth.centsdonations.com'
